<div *ngIf="item && item.cells" matTooltip="{{responseDaysAvailable}}" >
    {{ responseDaysAvailable }}
</div>
